'use client';

import { useCallback, type ComponentProps } from 'react';

import ServiceHeroSection from '@/components/sections/ServiceHeroSection/ServiceHeroSection';
import { usePharmacyBookingModal } from '@/features/pharamacy/components/PharmacyBookingModalContext/PharmacyBookingModalContext';

type ServiceHeroSectionProps = ComponentProps<typeof ServiceHeroSection>;

type PharmacyHeroWithBookingModalProps = {
  data: ServiceHeroSectionProps['data'];
};

export default function PharmacyHeroWithBookingModal({
  data,
}: PharmacyHeroWithBookingModalProps) {
  const { openModal } = usePharmacyBookingModal();

  const handleHeroButtonClick = useCallback<
    NonNullable<ServiceHeroSectionProps['onButtonClick']>
  >(
    (button, _index, event) => {
      const label = button.content?.replace(/\s+/g, ' ').trim();
      const isHeroBookingButton =
        button.link === '/book-appointment' || label === 'Book an appointment';

      if (!isHeroBookingButton) return;

      event.preventDefault();
      event.stopPropagation();

      openModal();
    },
    [openModal],
  );

  return (
    <div className="min-[820px]:max-[900px]:[--hero-small-tablet-main-top:-18px]">
      <ServiceHeroSection data={data} onButtonClick={handleHeroButtonClick} />
    </div>
  );
}
